import { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';

import TooltipDark from 'packages/kakapo-ui-kit/components/tooltips/TooltipDark';

const Container = styled.div`
	width: 36px;
	position: relative;

	&,
	* {
		cursor: default;
	}
`;

const CalendarIconMonth = styled.p`
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.danger};
	border-radius: 5px 5px 0 0;
	display: flex;
	font-size: 10px;
	align-items: center;
	justify-content: center;
	text-transform: uppercase;
	font-weight: 600;
	padding: 2px 5px 0 5px;
	line-height: 14px;
	font-smoothing: subpixel-antialiased;
`;
const CalendarIconDay = styled.p`
	color: ${(props) => props.theme.colors.antracite};
	background-color: ${(props) => props.theme.colors.white};
	display: flex;
	font-size: 16px;
	align-items: center;
	justify-content: center;
	border-radius: 0 0 5px 5px;
	padding: 2px 0;
`;

const CalendarIcon = ({ date }: { date: Date }) => {
	const [hover, setHover] = useState(false);

	return (
		<Container onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
			<TooltipDark isHovered={hover} direction="north">
				{moment(date).format('DD-MM-YYYY')}
			</TooltipDark>
			<CalendarIconMonth>{moment(date).format('MMM')}</CalendarIconMonth>
			<CalendarIconDay>{moment(date).date()}</CalendarIconDay>
		</Container>
	);
};

export default CalendarIcon;
